export default "__VITE_ASSET__BFVzmpfv__"